export default __webpack_public_path__ + "static/media/@danibonelli.d857e7b3.jpg";